import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import appConfig from './store/settings'; 

// เพิ่ม production path check
const getLoadPath = () => {
  // ในการ production, ใช้ absolute path หรือ relative path แบบ /locales
  if (appConfig.isDevMode) {
    return appConfig.defaultURL + 'locales/{{lng}}/{{ns}}.json';
  }
  // ใช้ /locales สำหรับ production (public folder)
  return '/locales/{{lng}}/{{ns}}.json';
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .use(Backend)
    .init({
      backend: {
        loadPath: getLoadPath(),
        addPath: '/locales/add/{{lng}}/{{ns}}'
      },
      fallbackLng: appConfig.language,
      debug: false,
      sSeparator: ':',
      keySeparator: ':',
      ns: ["member-page", "admin-page", "category-page", "component", "config-page", "contactms-page", "image", "langconfig", "login", "messages-page", "ns", "orders-page", "post-page", "product-page", "products-category-page", "research-page", "sidebar", "slide-page", "webinfo-page"],
      defaultNS: "component",
      interpolation: {
        escapeValue: false
      },
      lng: appConfig.language,
      load: 'languageOnly',
      cleanCode: true
    });

export default i18n;

